import { matchQuery, MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { handleApiError } from '@/shared/lib/errorHandler'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            // PERF FIX: Giữ staleTime 1 phút (match BE cache TTL ~60s)
            staleTime: 1000 * 60,
            // PERF FIX: Giữ data trong memory 5 phút → back navigation không refetch
            gcTime: 1000 * 60 * 5,
            // PERF FIX: Tắt refetch khi reconnect - socket sẽ trigger invalidate khi cần
            refetchOnReconnect: false,
        },
    },
    queryCache: new QueryCache({
        onError: (error, query) => {
            if (query.meta?.skipGlobalErrorHandler) {
                return
            }
            handleApiError(error)
        },
    }),
    mutationCache: new MutationCache({
        onSuccess: async (_data, _variables, _context, mutation) => {
            await queryClient.invalidateQueries({
                predicate: query =>
                    // invalidate all matching tags at once
                    // or everything if no meta is provided
                    (mutation.meta?.invalidates as any)?.some((queryKey: any) => matchQuery({ queryKey }, query)) ??
                    true,
            })
        },
        onError: (error, _variables, _context, mutation) => {
            // Skip if mutation explicitly disables global error handling
            if (mutation.meta?.skipGlobalErrorHandler) {
                return
            }
            handleApiError(error)
        },
    }),
})
